import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import { bytesToMb } from '@/utils/units';
import { Typography } from '@mui/material';
import Wrapper from '../Wrapper';
import ProgressBar from './ProgressBar';
import styles from './styles';
import { Props } from './utils';

export default function Progress({
  fileName = '',
  fileSize = 0,
  progress = 0,
  success = false,
  error = false,
  invalid = false,
  onRemove,
}: Props) {
  // Calc percentage based on 'progress' and 'success' properties
  let percentage = progress === 100 && !success ? 99 : progress;
  if (success) percentage = 100;

  // Constants
  let rightIcon = null;
  const leftIconColor = error ? '#F97066' : '#98A2B3';
  const content = error ? <Error /> : <Success progress={percentage} />;

  if (success) rightIcon = <CheckCircleOutlineOutlinedIcon />;
  if (error)
    rightIcon = (
      <Box component="span" onClick={onRemove} sx={styles.deleteIcon}>
        <DeleteOutlineOutlinedIcon />
      </Box>
    );

  return (
    <Wrapper invalid={invalid} error={error}>
      <Box>
        <FileUploadOutlinedIcon />
      </Box>
      <Stack sx={styles.body} justifyContent="space-between">
        <Stack direction="row" gap="8px">
          <Typography sx={styles.fileName}>{fileName}</Typography>
          {!error && (
            <>
              <Typography sx={styles.fileSize}>
                {bytesToMb(fileSize)} MB
              </Typography>
              {success && (
                <Typography sx={styles.remove} onClick={onRemove}>
                  Borrar
                </Typography>
              )}
            </>
          )}
        </Stack>
        {content}
      </Stack>
      <Stack
        justifyContent={error ? 'center' : 'space-between'}
        alignItems="flex-end"
      >
        {rightIcon}
        {!error && (
          <Typography sx={styles.percentage}>{percentage}%</Typography>
        )}
      </Stack>
    </Wrapper>
  );
}

function Success({ progress }: { progress: number }) {
  return <ProgressBar progress={progress} />;
}

function Error() {
  return (
    <Stack gap="8px" sx={styles.error.wrapper} direction="row">
      <Typography sx={styles.error.msgPrimary}>Ocurrió un error.</Typography>
      <Typography sx={styles.error.msgSecondary}>Intenta de nuevo</Typography>
    </Stack>
  );
}
